import { useCurrency } from "@/context/CurrencyContext";
import { Globe } from "lucide-react";

// Compact global currency selector. Placed in the public nav and the workspace shell so a chosen
// display currency follows the user across every page. Presentation only — GBP is always billed.
export default function CurrencySelect({ compact = false }) {
  const { currency, setCurrency, currencies } = useCurrency();
  if (!currencies.length) return null;
  return (
    <label className="k-currency-select" data-testid="currency-select-wrap"
      style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer" }}
      title="Display currency (Kadana always bills in GBP)">
      <Globe size={15} color="var(--accent-primary)" aria-hidden="true" />
      <select className="k-control" data-testid="global-currency-select" aria-label="Display currency"
        value={currency} onChange={e => setCurrency(e.target.value)}
        style={{ width: "auto", padding: compact ? "6px 8px" : "8px 10px", fontSize: 13 }}>
        {currencies.map(c => (
          <option key={c.code} value={c.code}>
            {c.code}{c.symbol && c.symbol !== c.code ? ` (${c.symbol})` : ""}
          </option>
        ))}
      </select>
    </label>
  );
}
